var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wkb-markdown-block" },
    [
      _vm._l(_vm.blocks, function (block, index) {
        return [
          block.type === "list"
            ? _c(
                "ul",
                { key: `list-${index}`, staticClass: "wkb-markdown-list" },
                _vm._l(block.items, function (item, itemIndex) {
                  return _c("li", { key: `item-${index}-${itemIndex}` }, [
                    _vm._v(" " + _vm._s(item) + " "),
                  ])
                }),
                0
              )
            : block.type === "h3"
            ? _c("h3", { key: `h3-${index}`, staticClass: "wkb-markdown-h3" }, [
                _vm._v(" " + _vm._s(block.text) + " "),
              ])
            : block.type === "h2"
            ? _c("h2", { key: `h2-${index}`, staticClass: "wkb-markdown-h2" }, [
                _vm._v(" " + _vm._s(block.text) + " "),
              ])
            : block.type === "h1"
            ? _c("h1", { key: `h1-${index}`, staticClass: "wkb-markdown-h1" }, [
                _vm._v(" " + _vm._s(block.text) + " "),
              ])
            : _c("p", { key: `p-${index}`, staticClass: "wkb-markdown-p" }, [
                _vm._v(" " + _vm._s(block.text) + " "),
              ]),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }